// extracted by mini-css-extract-plugin
export default {"pillSmall":"style_pillSmall__pho5P","interactive":"style_interactive__MbboA","good":"style_good__E0VW2","poor":"style_poor__mGWt2","label":"style_label__ZzWcc"};